<template>
  <div style="position: relative">
    <div
      style="
        position: absolute;
        height: 70vh;
        top: 0;
        left: 0;
        right: 0;
        background-position: center;
        background-size: cover;
      "
    ></div>
    <v-container style="position: relative">
      <v-layout
        text-center
        wrap
        justify-center
        v-if="!line_error"
        class="mb-5"
        style="
          position: relative;
          top: 50px;
          width: 100%;
          max-width: 500px;
          margin-left: auto;
          margin-right: auto;
        "
      >
        <v-card style="width: 100%" flat>
          <v-card-text>
            <div class="pt-5 pb-5">
              <div>
                <v-img
                  style=""
                  :src="`${publicPath}img/hoppinlogo.png`"
                ></v-img>
              </div>
              <ValidationObserver
                tag="form"
                ref="observer"
                v-slot="{ invalid, validated }"
              >
                <form>
                  <ValidationProvider
                    :rules="'required'"
                    key="Username"
                    name="Username"
                    v-slot="{ errors, valid }"
                  >
                    <v-text-field
                      v-model="input.username"
                      label="Username"
                      placeholder="abc@gmail.com"
                      :error-messages="errors"
                      :success="valid"
                    >
                      <template slot="append">
                        <v-img
                          :src="`${publicPath}img/usericon.png`"
                          width="25px"
                          class="mb-1"
                        >
                        </v-img>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors, valid }"
                    name="Password"
                  >
                    <v-text-field
                      v-model="input.password"
                      :type="show ? 'text' : 'password'"
                      label="Password"
                      :error-messages="errors"
                      :success="valid"
                    >
                      <div slot="append" @click="show = !show">
                        <template v-if="input.password.length > 0">
                          <v-icon style="color: darkgrey">{{
                            show ? "mdi-eye-outline" : "mdi-eye-off-outline"
                          }}</v-icon>
                        </template>
                        <template v-else>
                          <v-img
                            :src="`${publicPath}img/keyicon.png`"
                            width="18px"
                            class="mb-1"
                          >
                          </v-img>
                          <!-- <v-icon style="color: darkgrey"
                            >mdi-lock-outline</v-icon
                          > -->
                        </template>
                      </div>
                    </v-text-field>
                  </ValidationProvider>
                </form>
                <div class="red--text mb-3">{{ errorMessage }}</div>
                <div class="text-left">
                  <v-row>
                    <v-col cols="6">
                      <vue-recaptcha
                        ref="recaptcha"
                        @verify="loginByUsername"
                        @expired="onExpired"
                        sitekey="6LcgG70UAAAAAAoXoXwhax-FIRosRMTXF_1NX8nN"
                      >
                        <v-btn
                          small
                          color="primary"
                          depressed
                          style="background-color: #034f9aff !important; border: #190065 solid 1px; width:180px;"
                          class="mb-1 text-capitalize"
                          :loading="loading"
                          >Sign In</v-btn
                        >
                      </vue-recaptcha>
                    </v-col>
                    <v-col cols="6"></v-col>
                  </v-row>
                </div>
              </ValidationObserver>
              <div class="text-left">
                <v-row>
                  <v-col cols="6">
                    <v-btn
                      @click="joinHopinnReward"
                      small
                      color="primary"
                      depressed
                      class="text-capitalize"
                      style="background-color: #034f9aff !important; border: #190065 solid 1px; width:180px;"
                      >Become a member</v-btn
                    >
                  </v-col>
                  <v-col cols="6">
                    <div class="text-right">
                      <v-btn
                        @click="forgotpassword"
                        class="text-capitalize"
                        color="red"
                        text
                        >Forgot password?</v-btn
                      >
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-layout>
      <!-- <div
        class="caption grey--text mt-5 text-center"
        style="position: relative; top: 50px"
      >
        © HOP INN Hotel Thailand 2019 (c) All Rights Reserved.
      </div> -->
    </v-container>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import axios from "axios";
export default {
  data: () => {
    return {
      publicPath: process.env.BASE_URL,
      input: {
        username: "",
        password: "",
      },
      lineid: "",
      show: false,
      loading: false,
      errorMessage: "",
      line_error: false,
    };
  },
  components: {
    VueRecaptcha,
  },
  mounted: async function() {
    if (this.$route.query.lineid) {
      this.lineid = this.$route.query.lineid;
    }
    await this.getUsernameDefault();
    await this.$refs.observer.validate();
    this.$refs.observer.reset();
    await this.$liff.init({ liffId: process.env.VUE_APP_HOME_LIFF_ID });
    await this.$nextTick();
    this.loading = false;
  },
  methods: {
    forgotpassword() {
      window.location.assign(
        "https://www.hopinnhotel.com/reset-password?signInEmail=" +
          this.input.username
      );
    },
    joinHopinnReward() {
      window.location.assign("https://www.hopinnhotel.com/sign-up-page");
    },
    getUsernameDefault() {
      return new Promise((resolve) => {
        var vm = this;
        axios
          .get("https://api-enterprise.zwiz.app/hopinnusernamelogin", {
            params: {
              lineid: vm.$route.query.lineid,
              pageid: vm.$route.query.pageid,
            },
          })
          .then((response) => {
            if (response.data.responsecode == 200) {
              Object.assign(vm.input, {
                username: response.data.username,
              });
              // vm.input.username = response.data.username;
            }
            resolve();
          });
      });
    },
    onSubmit: async function(token) {
      var vm = this;
      vm.errorMessage = "";

      vm.loading = true;
      var data = {
        userid: vm.input.username,
        password: vm.input.password,
        "g-recaptcha-response": token,
        lineid: vm.lineid,
        pageid: vm.$route.query.pageid,
      };
      try {
        var response = await axios.post(
          "https://api-enterprise.zwiz.app/hopinnusernamelogin",
          data
        );
        vm.loading = false;
        if (response.data.responsecode === 200) {
          if (
            typeof vm.$liff !== "undefined" &&
            typeof vm.$liff.sendMessages === "function"
          ) {
            vm.$liff
              .sendMessages([
                {
                  type: "text",
                  text: "Member Info",
                },
              ])
              .then(() => {
                vm.$liff.closeWindow();
              });
          } else {
            /* eslint-disable no-undef */

            if (window.MessengerExtensions) {
              MessengerExtensions.requestCloseBrowser(
                function success() {},
                function error(err) {
                  console.error(err);
                  try {
                    close();
                    window.close();
                  } catch (error) {
                    console.error(error);
                  }
                  setTimeout(() => {
                    window.location.href = `https://m.me/${data.pageid}`;
                  }, 300);
                }
              );
            } else {
              try {
                close();
                window.close();
              } catch (error) {
                console.error(error);
              }
              setTimeout(() => {
                window.location.href = `https://m.me/${data.pageid}`;
              }, 300);
            }
            /* eslint-enable no-undef */
          }
        } else {
          if (response.data.reason == "Authorization Failure") {
            vm.errorMessage =
              "Sorry, your password was incorrect. Please double-check your password.";
          } else {
            vm.errorMessage = response.data.reason;
          }
        }
      } catch (error) {
        vm.errorMessage = "Something went wrong";
      }
    },
    loginByUsername: async function(response) {
      let vm = this;
      var isValid = await this.$refs.observer.validate();

      if (!isValid) {
        vm.resetRecaptcha();
        return false;
      } else {
        await vm.onSubmit(response);
      }
    },
    onExpired: function() {},
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
  },
};
</script>

<style lang="scss">
.grecaptcha-badge {
  width: 1px;
  height: 1px;
  visibility: hidden;
}
</style>
